import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "0.5rem",
    "background-color": "#f4f4f4"
  }
}, null, -1);

const _hoisted_2 = {
  style: {
    "padding": "0.5rem",
    "font-size": ".6rem",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_3 = {
  style: {
    "color": "#999"
  }
};
const _hoisted_4 = {
  style: {
    "color": "#999"
  }
};
const _hoisted_5 = {
  style: {
    "color": "#999"
  }
};
const _hoisted_6 = {
  style: {
    "color": "#999"
  }
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "0.5rem",
    "background-color": "#f4f4f4"
  }
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx._t("homeHintTit")), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx._t("homeHint1")), 1), _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx._t("homeHint2")), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx._t("homeHint3")), 1)]), _hoisted_7]);
}